import React from "react";
import SystemGraphs from "./SystemGraphs";

const VancilOps = () => {
  const defaultParameter = 67;

  const pageTitle = "Vancil Operations";

  const endpoints = [
    { label: "15 Minutes", value: "display005-data15-min-ax1" },
    { label: "Daily", value: "display005-data-daily-ax1" },
  ];

  const parametersEndpoint = "display005-lookup-parameter";

  const mapEndpoint = "display005-map-points";

  return (
    <>
      <SystemGraphs
        defaultParameter={defaultParameter}
        pageTitle={pageTitle}
        endpoints={endpoints}
        parametersEndpoint={parametersEndpoint}
        mapEndpoint={mapEndpoint}
        //if rightAxis is true, then the graph will add a right axis based on the
        //current endpoints, only it will sub a 2 on the end instead of the 1
        rightAxis={true}
      />
    </>
  );
};

export default VancilOps;
